export default {
  vision_blog: "FraudVision 博客".toUpperCase(),
  stay_turned_for__: "Stay tuned for everything happening on Vision.".toUpperCase(),
  all: "全部",
  articles: "文章".toUpperCase(),
  show_more: "展开更多".toUpperCase(),
};
